module.exports = __webpack_public_path__ + "static/media/992242.2681a303.png";